<template>
  <v-row justify="center">
    <v-dialog v-model="showDialog"
              persistent max-width="200"
              :close-on-content-click="false"
              offset-x>
      <v-card flat>
        <v-toolbar color="primary"
                   flat>
          <v-toolbar-title style="color: #ffffff; font-weight: 500;" v-html="`Flag Task`"></v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn color="white" style="margin-right: 1px;" icon class="text-right ml-3" @click="toggle">
            <v-icon color="#ffffff" size="32">close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-radio-group v-model="flag" column>
            <v-radio label="ATTN"
                     color="error"
                     value="ATTN"></v-radio>
            <v-radio label="PON"
                     color="error"
                     value="PON"></v-radio>
            <v-radio label="ATTN & PON"
                     color="error"
                     value="BOTH"></v-radio>
            <v-radio label="No Flag"
                     color="success"
                     value="NONE"></v-radio>
          </v-radio-group>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="showMessage" :color="messageColour" timeout="1000">
      {{ message }}
    </v-snackbar>
  </v-row>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'flag-task',
  props: {
    showDialog: {
      type: Boolean,
      required: true
    },
    toggle: {
      type: Function,
      required: true
    }
  },
    data: () => ({
      messageColour: 'success',
      showMessage: false,
      message: 'Saved'
  }),
  methods: {
    ...mapActions({
      updateTask: 'workOrderTask/updateTask'
    }),



  },
  computed: {
    ...mapGetters({
      task: 'workOrderTask/selectedTask',
      error: 'workOrderTask/error',
    }),
    flag: {
      get() {
        return this.task.flagged
      },
      async set(value) {
        this.showMessage = false
        this.task.flagged = value

        await this.updateTask(this.task)
        this.showMessage = true

        if (this.error !== null) {
          this.message = 'Error Saving Flag'
          this.messageColour ='error'
        } else {
          this.message = 'Flag Saved'
          this.messageColour ='success'
        }
      }
    }

  }
}
</script>
